import { defineStore } from "pinia"

export interface PopupOptions {
  style: "success" | "warn" | "error"
  text: string
  duration?: number
}

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    popup: {
      style: "success",
      text: "",
      duration: 0,
    } as PopupOptions,
    loading: false,
  }),
  actions: {
    setpopup(popup: PopupOptions) {
      this.popup = popup
    },
    startLoading() {
      this.loading = true
    },
    loadingDone() {
      this.loading = false
    },
  },
})
